import React, { Component } from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import { data } from "../../../assets/data/index";
import InputMask from "react-input-mask";
import CommonService from "../../../services/common-service";
import MaskConfig from "../../../config/maskConfig";
import FormsService from "../../../services/FormsService";
import LocalStoreService from "../../../services/localStore-service";
import UserService from "../../../services/user-service";
import ModalPopup from "../../Shared/ModalPopup/ModalPopup";
import CarInfoModal from "../../PostAd/SellCar/CarInfoModal/CarInfoModal"

import "./QueryForm.scss";
class QueryForm extends Component {
  constructor() {
    super();
    this.commonService = new CommonService();
    this.maskConfig = new MaskConfig();
    this.formsService = new FormsService();
    this.commonService = new CommonService();
    this.userService = new UserService();
    this.localService = new LocalStoreService();
    this.state = {
      showCarInfoModal: false,
      cities: [],
      id: "",
      name: "",
      city: "",
      email: "",
      message: "",
      phoneNumber: "",
      type: "",
      carInfo: "",
      car: "",
      errors: {
        name: "",
        city: "",
        email: "",
        message: "",
        carInfo: "",
        phoneNumber: "",
      },
    };
  }

  componentDidMount() {
    this.getCities();
    this.setState({
      carInfo: this.props.carInfo,
      type: this.props.type,
    });
  }

  getCities() {
    let cities = [];
    data.pakCities.forEach((city) => {
      cities.push({ label: city.name, value: city.name });
    });
    this.setState({ cities });
  }

  handleChange = (e, actionMeta) => {
    if (e.target) {
      const { value, name, type, checked } = e.target;

      this.checkFormErrors(name, value);
      this.setState({
        ...this.state,
        [name]: type === "checkbox" ? checked : value,
      });
    } else if (actionMeta && actionMeta.name) {
      const value = e.value;
      const { name } = actionMeta;
      this.checkFormErrors(name, value);
      this.setState({
        ...this.state,
        [name]: value,
      });
    }
  };
  modalClose = () => {
    this.props.modalClose();
  };

  toggleCarInfoModel = () => {
    this.setState({
      showCarInfoModal: !this.state.showCarInfoModal,
    });
  };

  setFormData = () => {
    const {
      name,
      city,
      email,
      phoneNumber,
      message,
      carInfo,
      type,
    } = this.state;
    const formData = { name, city, email, phoneNumber, message, carInfo, type };
    return formData;
  };

  submit = () => {
    let formData = this.setFormData();
    if (this.isValidForm(formData, this.state.errors)) {
      this.formsService
        .addFormsService(formData)
        .then((res) => {
          const { message, data } = res.data;
          if (message === "Query Form added successfully") {
            this.commonService.showToast(
              "Query form submitted successfully!",
              "success"
            );
            this.modalClose();
            this.setState({
              id: data ? data.id : 0,
            });
          } else {
            this.commonService.showToast("Query form not submitted!", "error");
          }
        })
        .catch((err) => {
          this.commonService.showToast("Something went wrong!", "error");
          this.userService.handleError(err);
        });
    } else {
      this.commonService.showToast("Invalid form!", "error");
    }
  };

  handleRef = (e) => {
    let { refs } = this.state;
    if (e && e.name) {
      refs[e.name] = e;
      refs.images = ReactDOM.findDOMNode(this.refs.images);

      this.setState({ refs });
    } else if (e && e.props && e.props.name) {
      refs[e.props.name] = e.select;
      this.setState({ refs });
    }
  };

  focusOnError = (errors) => {
    if (errors) {
      for (let key in errors) {
        if (errors[key]) {
          if (this.state.refs[key]) {
            this.state.refs[key].focus();
            break;
          }
        }
      }
    }
  };

  isValidForm = (formData, errors) => {
    for (let key in formData) {
      this.checkFormErrors(key, formData[key]);
    }
    // this.focusOnError(errors);

    return this.commonService.checkFormValidity(this.state.errors);
  };

  handleCarInfoModalClose = (carInfo) => {
    this.toggleCarInfoModel();
    this.setCarInfo(carInfo, "add");
    const { make, model, variant } = carInfo;
    this.setState({
      makeId: make.id,
      modelId: model.id,
      variantId: variant.id,
    });
  };

  setCarInfo = ({ year, make, model, variant }, type) => {
    const info = `${year && year.value ? year.value : ""} ${
      make.name ? make.name : ""
    } ${model.name ? model.name : ""} ${
      variant && variant.name ? variant.name : ""
    }`;
    const title = `${make && make.name ? make.name : ""} ${
      model && model.name ? model.name : ""
    } ${year && year.value ? year.value : ""} ${
      variant && variant.name ? variant.name : ""
    }`;

    this.setState(
      {
        carInfo: title,
        modelYear: year ? year.value : "",
        car: { year, make, model, variant },
      },
      () => {
        console.log(this.state.carInfo);
      }
    );

    if (variant && variant.car) {
      const { price } = variant.car;
      this.setState({
        carPrice: price,
      });
    }
  };

  checkFormErrors = (name, value) => {
    let errors = this.state.errors;

    switch (name) {
      case "carInfo":
        errors.carInfo = value === "" ? "Car Info is required!" : "";
        break;
      case "name":
        errors.name = value === "" ? "Name is required!" : "";
        break;
      case "city":
        errors.city = value === "" ? "City is required!" : "";
        break;
      case "email":
        errors.email =
          value === ""
            ? "Email is required!"
            : this.commonService.isEmailValid(value)
            ? ""
            : "Email is not valid!";
        break;
      case "phoneNumber":
        errors.phoneNumber = !value
          ? "Phone number is required!"
          : value.length < 11
          ? "Invalid phone number!"
          : "";
      case "message":
        errors.message = value === "" ? "Message is required!" : "";
      default:
        break;
    }
    this.setState({ errors });
  };

  render() {
    const {
      name,
      city,
      email,
      phoneNumber,
      message,
      errors,
      cities,
      carInfo,
      car,
    } = this.state;
    return (
      <div className="query-form-main">
        <div className="container">
          <h2>Query Form</h2>
          <div className="row">
            <div className="form-group col-md-6 col-sm-6">
              <label>
                Name<span className="text-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={name}
                placeholder="Name*"
                onChange={this.handleChange}
              />
              {errors.name && (
                <div className="invalid-feedback d-block">{errors.name}</div>
              )}
            </div>
            <div className="form-group col-md-6 col-sm-6">
              <label>
                City<span className="text-error">*</span>
              </label>
              <div className="post-catagories">
                <Select
                  options={cities}
                  name="city"
                  value={city}
                  placeholder="Select City"
                  onChange={this.handleChange}
                />
                {errors.city && (
                  <div className="invalid-feedback d-block">{errors.city}</div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-md-6 col-sm-6">
              <label>
                Email<span className="text-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="email"
                value={email}
                placeholder="Email"
                onChange={this.handleChange}
              />
              {errors.email && (
                <div className="invalid-feedback d-block">{errors.email}</div>
              )}
            </div>
            <div className="form-group col-md-6 col-sm-6">
              <label>
                Phone Number<span className="text-error">*</span>
              </label>
              <InputMask
                mask={this.maskConfig.phoneNumberMask}
                maskChar={null}
                className={`form-control ${errors.phoneNumber ? "error" : ""}`}
                name="phoneNumber"
                placeholder="03XXXXXXXXX"
                value={phoneNumber}
                onChange={this.handleChange}
              />
              {errors.phoneNumber && (
                <div className="invalid-feedback d-block">
                  {errors.phoneNumber}
                </div>
              )}
            </div>
          </div>
          <div className="row">
            {this.props.type === "certified-cars" && (
              <div className="form-group col-md-6 col-sm-6">
                <label htmlFor="firstName">Car info*</label>
                <input
                  type="text"
                  className={`custom-pointer-cursor-class form-control  ${
                    errors.carInfo ? "error" : ""
                  }`}
                  name="carInfo"
                  placeholder="Year* / Make* / Model* / Variant"
                  value={carInfo}
                  onClick={this.toggleCarInfoModel}
                  readOnly
                />
                {errors.carInfo && (
                  <div className="invalid-feedback d-block">
                    {errors.carInfo}
                  </div>
                )}
              </div>
            )}
            <div className="form-group col-md-6 col-sm-6">
              <label>
                Message<span className="text-error">*</span>
              </label>
              <textarea
                className="form-control"
                name="message"
                value={message}
                onChange={this.handleChange}
                rows="3"
              ></textarea>
              {errors.message && (
                <div className="invalid-feedback d-block">{errors.message}</div>
              )}
            </div>
          </div>
          <div className="query-form-submit mt-2">
            <button
              type="button"
              className="btn btn-submit"
              onClick={this.submit}
            >
              Submit
            </button>
            <button
              type="button"
              className="btn ml-4 btn-cancel"
              onClick={this.modalClose}
            >
              Cancel
            </button>
          </div>
        </div>
        <ModalPopup
          isOpen={this.state.showCarInfoModal}
          onModalClose={this.toggleCarInfoModel}
          className="postyouradd-carinfo"
          backdrop={"static"}
        >
          {" "}
          <CarInfoModal
            onCarInfoClose={this.handleCarInfoModalClose}
            category="car"
            carInfo={car}
          />{" "}
        </ModalPopup>
      </div>
    );
  }
}
export default QueryForm;
